//TODO we need a tag model!!!! see tags in searchcontainer vs text only tags!
<template>
  <div
    v-if="tags && tags.length>0"
    class="flex flex-row mt-1"
  >
    <div
      v-for="tag in tags"
      :key="tag"
    >
      <span
        class="p-tag mr-1"
        @click="onTagClicked"
      >
        {{ tag }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
    name: 'TagList',
    props: {
        tags: {}
    },
    methods: {
        onTagClicked (data) {
            this.$emit('tagClicked', data)
        }
    }
}
</script>